export default __webpack_public_path__ + "static/media/Camion4-t.f50827b3.png";